import { mergeStyles, Modal, PrimaryButton, Stack, useTheme } from '@fluentui/react';
import React from 'react';
import { BaseComponentProps, ButtonGroup, Input } from '..';

export const Consent = (props: BaseComponentProps): JSX.Element => {
  const { onSubmit, inputs } = props;
  const theme = useTheme();
  const [isModalOpen, setIsModalOpen] = React.useState(true);
  const width = Math.min(window.innerWidth, window.outerWidth) - 64;

  const handleOnSubmit = (input: Input) => {
    setIsModalOpen(false);
    onSubmit && onSubmit([input]);
  };

  const onSubmitConsentButton = () => {
    setIsModalOpen(true);
  };

  if (!isModalOpen) {
    return <ConsentButton onSubmit={onSubmitConsentButton} />;
  }

  return (
    <Modal
      isOpen={isModalOpen}
      styles={{ main: { borderRadius: theme.effects.roundedCorner6 } }}
      allowTouchBodyScroll={true}
    >
      <div
        className={mergeStyles({
          padding: '1rem',
          boxShadow: theme.effects.elevation8,
          width: width,
          borderRadius: `${theme.effects.roundedCorner6} ${theme.effects.roundedCorner6} 0 0`,
          background: theme.palette.neutralPrimary,
        })}
      >
        <Stack
          style={{
            height: '100%',
            color: 'black',
            paddingBottom: '1rem',
            overflowY: 'scroll',
          }}
        >
          <h3>{inputs?.find((i) => i.name === 'title')?.value}</h3>
          <div style={{ maxHeight: window.innerHeight / 2, overflow: 'auto' }}>
            {inputs?.find((i) => i.name === 'body')?.valueJSX}
          </div>
        </Stack>
        <Stack horizontal horizontalAlign="space-evenly">
          <PrimaryButton
            className={mergeStyles({
              height: '3rem',
              color: 'black',
              minWidth: '8rem',
              borderRadius: theme.effects.roundedCorner6,
              boxShadow: theme.effects.elevation8,
            })}
            onClick={() =>
              handleOnSubmit({
                id: props?.inputs[0]?.name,
                name: 'Yes',
                key: props?.inputs[0]?.key,
                value: 'Yes',
              })
            }
          >
            Yes
          </PrimaryButton>
          <PrimaryButton
            className={mergeStyles({
              height: '3rem',
              color: 'black',
              minWidth: '8rem',
              borderRadius: theme.effects.roundedCorner6,
              boxShadow: theme.effects.elevation8,
            })}
            onClick={() =>
              handleOnSubmit({
                id: props?.inputs[0]?.name,
                name: 'No',
                key: props?.inputs[0]?.key,
                value: 'No',
              })
            }
          >
            No
          </PrimaryButton>
        </Stack>
      </div>
    </Modal>
  );
};

export interface ConsentButtonProps {
  onSubmit?: () => void;
}

export const ConsentButton = (props: ConsentButtonProps): JSX.Element => {
  const { onSubmit } = props;
  return (
    <ButtonGroup
      onSubmit={async () => onSubmit && onSubmit()}
      inputs={[
        {
          id: 'sign',
          key: 'sign',
          value: 'Patient Authorization Consent Form',
          name: 'Patient Authorization Consent Form',
        },
      ]}
    />
  );
};

export interface InlineConsentProps {
  children: React.ReactNode;
  content: string;
}
